import axios, { AxiosResponse } from "axios";
import { Blog } from "../@types/blog";

class BlogService {
  private BASE_URL = "https://sodastreamapi.azurewebsites.net/blogs";

  async getAllBlogs(): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.get(this.BASE_URL);
      if (response.status >= 200 && response.status < 300) {
        const blogs: Blog[] = response.data;

        return { data: blogs, error: null };
      } else {
        const error = "Error fetching blogs";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching blogs:", error);
      return { data: null, error };
    }
  }

  async getBlogById(
    blogId: any
  ): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<Blog> = await axios.get(
        `${this.BASE_URL}/id/${blogId}`
      );
      if (response.status >= 200 && response.status < 300) {
        const blog: Blog = response.data;

        return { data: blog, error: null };
      } else {
        const error = "Error fetching blog by ID";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching blog by ID:", error);
      return { data: null, error };
    }
  }

  async getBlogByLink(
    bloglink: string
  ): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<Blog> = await axios.get(
        `${this.BASE_URL}/${bloglink}`
      );
      if (response.status >= 200 && response.status < 300) {
        const blog: Blog = response.data;

        return { data: blog, error: null };
      } else {
        const error = "Error fetching blog by link";
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error fetching blog by link:", error);
      return { data: null, error: error.message };
    }
  }

  async createBlog(
    blogData: any
  ): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<Blog> = await axios.post(
        this.BASE_URL,
        blogData
      );
      if (response.status >= 200 && response.status < 300) {
        const createdBlog: Blog = response.data;

        return { data: createdBlog, error: null };
      } else {
        const error = `Error creating blog - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error creating blog:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async editBlog(
    blogId: any,
    updatedBlogData: any
  ): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<Blog> = await axios.put(
        `${this.BASE_URL}/id/${blogId}`,
        updatedBlogData
      );
      if (response.status >= 200 && response.status < 300) {
        const updatedBlog: Blog = response.data;
        return { data: updatedBlog, error: null };
      } else {
        const error = `Error updating blog - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error updating blog:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }

  async deleteBlog(
    blogId: number
  ): Promise<{ data: any | null; error: string | null }> {
    try {
      const response: AxiosResponse<any> = await axios.delete(
        `${this.BASE_URL}/id/${blogId}`
      );

      if (response.status >= 200 && response.status < 300) {
        return { data: response.data, error: null };
      } else {
        const error = `Error deleting blog - ${response.status}: ${response.statusText}`;
        console.error(error);
        return { data: null, error };
      }
    } catch (error: any) {
      console.error("Error deleting blog:", error.message);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      }
      return { data: null, error: error.message };
    }
  }
}

const blogServiceInstance = new BlogService();
export default blogServiceInstance;
